import CryptoJS from "crypto-js"

export const generateUniqueNick = async () => {
	const randomString = Math.random().toString(36).substring(2)
	return CryptoJS.MD5(randomString).toString()
}

export const sleep = (s) => new Promise((r) => setTimeout(r, s*1000))

export const getRelativeUrl = (absoluteUrl) => {
  if (!absoluteUrl) return null
  const url = new URL(absoluteUrl)
  return url.pathname + url.search
}

export const parseUtcDate = (value) => {
    if (!value)
        return null

    if (typeof value === "string" && !/[zZ]|[+-]\d{2}:?\d{2}$/.test(value))
        return new Date(`${value}Z`)

    return new Date(value)
}

export const formatDateTimeInTimezone = (value, timeZone = "America/Sao_Paulo") => {
    const date = parseUtcDate(value)

    if (!date || Number.isNaN(date.getTime()))
        return ""

    return new Intl.DateTimeFormat("pt-BR", {
        timeZone,
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
    }).format(date).replace(",", "")
}

export const formatSaoPauloDateTime = (value) => formatDateTimeInTimezone(value, "America/Sao_Paulo")

export const isValidCPF = (cpf) => {
  if (!cpf) return true;

  const cleaned = String(cpf).replace(/\D/g, '');

  if (cleaned.length !== 11) return false;

  if (/^(\d)\1+$/.test(cleaned)) return false;

  const calculateDigit = (digits, length) => {
    let sum = 0;
    for (let i = 0; i < length - 1; i++) {
      sum += parseInt(digits[i], 10) * (length - i);
    }
    const remainder = sum % 11;
    return remainder < 2 ? 0 : 11 - remainder;
  };

  const firstDigit = calculateDigit(cleaned, 10);
  if (firstDigit !== parseInt(cleaned[9], 10)) return false;

  const secondDigit = calculateDigit(cleaned, 11);
  return secondDigit === parseInt(cleaned[10], 10);
};

export const hasActivePlatforms = (platforms) => {
    return [
        "chat_web",
        "email",
        "instagram",
        "messenger",
        "msteams",
        "telegram",
        "whatsapp",
    ].some(key => platforms[key] === true)
}
